module.exports = __webpack_public_path__ + "static/media/lanchonete.18575ea0.jpg";